module.exports = __webpack_public_path__ + "static/graphik-light-0ab63e6fdb982ebcde4325253df0e240.woff";